import React from "react";
import OcancerzStarFormItems from "./OcancerzStarFormItems";

const OcancerzStarFormFun = (props) => {
  return (
    <div
      className="posts-grid"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0, // CRITICAL: Stops flex children from pushing bounds out
        boxSizing: "border-box",
      }}
    >
      {props.postFunction
        .map((post) => (
          <OcancerzStarFormItems
            key={post.uid || post._id}
            onEditPost={props.onEditPost}
            postFunction={post}
            refreshFeedBubbles={props.refreshFeed}
          />
        ))
        .reverse()}
    </div>
  );
};

export default OcancerzStarFormFun;
